module.exports = __webpack_public_path__ + "media/assets/images/flags/md-b940aeb4eb7e924321329053725f0b48.svg";